<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconkaoshi1"></i>
      学生列表
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <el-input
              v-model="stu_name"
              placeholder="请输入姓名"
              class="margin-right-sm"
          ></el-input>
          <el-input
              v-model="stu_phone"
              placeholder="请输入手机号"
              class="margin-right-sm"
          ></el-input>
          <el-input
              v-model="stu_idcard"
              placeholder="请输入身份证号"
              class="margin-right-sm"
          ></el-input>
          <el-button type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>
      </div>
      <div class="table-warpper">
        <el-table
            :data="studentList"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            fit
            style="width: 100%"
        >
          <el-table-column width="70" type="index" align="center" label="序号">
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.stu_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="性别">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.stu_sex === 1 ? '男' : '女' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份号">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.stu_idcard }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="手机号">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.stu_phone }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="电子邮箱">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.stu_email }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="table-operate">
                <router-link :to="'/train/examineeDetail?id=' + scope.row.id" class="margin-lr-xs">
                  <el-button
                      size="medium"
                      type="primary"
                  >查看详情
                  </el-button>
                </router-link>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
            v-if="studentList.length > 0"
            class="page-all"
            background
            :current-page.sync="page"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>

import {orgExamStudentList} from "@/api/fuse";

export default {
  name: "examinee",
  data() {
    return {
      id: '',
      stu_name: "",
      stu_idcard: "",
      stu_phone:'',
      studentList: [],
      page: 1,
      total: 0,
      limit: 10,
    }
  },
  created() {
    this.$emit(
        "setIndex",
        '/train/exam',
        "当前位置：学生列表",
        true
    );
    this.id = this.$route.query.id
    if (this.$route.query.page){
      this.page = Number(this.$route.query.page), this.stu_name = this.$route.query.stu_name, this.stu_idcard = this.$route.query.stu_idcard, this.stu_phone = this.$route.query.stu_phone
    }
    this.getList()
  },
  methods: {
    async getList() {
      let _list = await orgExamStudentList(this.id, this.page, this.limit, this.stu_name, this.stu_phone, this.stu_idcard)
      this.studentList = _list.data.list
      this.total = _list.data.count
    },
    //  修改路径
    setPath() {
      this.$router.push({
        path: '/train/examinee',
        query: {
          id: this.$route.query.id,
          page: this.page,
          stu_name: this.stu_name,
          idcard: this.idcard,
        }
      })
    },
    onSearch() {
      if (this.page === 1) {
        this.setPath()
      } else {
        this.page = 1;
      }
    },
  },
  watch: {
    page() {
      this.setPath()
    },
    $route() {
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">

</style>